/**
 * `localStorage` 기반 `StorageAdapter`. `deviceId` 를 재방문 간에 유지하는 것이 유일한 용도다.
 *
 * 접근을 감싸는 이유: 사파리 프라이빗 모드나 서드파티 컨텍스트에서 `localStorage` 접근이
 * **예외를 던진다.** 저장소를 못 쓰는 것이 재생을 막을 이유는 없다 —
 * 그때는 `deviceId` 가 세션마다 바뀌고, 그건 이 MVP 에서 감당할 수 있는 손실이다.
 */
export class LocalStorageAdapter {
    get(key) {
        try {
            return localStorage.getItem(key);
        }
        catch {
            return null;
        }
    }
    set(key, value) {
        try {
            localStorage.setItem(key, value);
        }
        catch {
            // 무시한다. 위 주석 참조.
        }
    }
}
//# sourceMappingURL=local-storage.js.map